import {lazy} from 'react';

const loadModule = () => import('./routes/ModuleRoutes');
export const ContractsModule = lazy(loadModule);

export default ContractsModule;
